export const SET_TRANSACTIONS = 'SET_TRANSACTIONS';
export const SET_TRANSACTION = 'SET_TRANSACTION';
export const SAVE_CHARGE_ID = 'SAVE_CHARGE_ID';
export const CLEAR_CHARGE_ID = 'CLEAR_CHARGE_ID';
export const SET_TRANSACTIONS_TOTAL_AMOUNT = 'SET_TRANSACTIONS_TOTAL_AMOUNT';
export const CLEAR_TRANSACTIONS_TOTAL_AMOUNT = 'CLEAR_TRANSACTIONS_TOTAL_AMOUNT';
export const SET_PAYNOW_TRANSACTION_FEATURE = 'SET_PAYNOW_TRANSACTION_FEATURE';
export const SET_PAYNOW_TRANSACTION_PAGINATION_PARAMS = 'SET_PAYNOW_TRANSACTION_PAGINATION_PARAMS';
export const SET_PAYNOW_TRANSACTION_PAGE_SIZE = 'SET_PAYNOW_TRANSACTION_PAGE_SIZE';
export const SHOW_OLD_TRANSACTIONS = 'SHOW_OLD_TRANSACTIONS';


// WEBPACK FOOTER //
// ./src/store/modules/transactions/mutations.js